import React from "react";
import { Link } from "react-router-dom";
import { FaApple, FaGoogle, FaLink, FaTimes } from "react-icons/fa";

interface AccountLinkingBannerProps {
  onDismiss: () => void;
}

export const AccountLinkingBanner: React.FC<AccountLinkingBannerProps> = ({
  onDismiss,
}) => {
  return (
    <div
      className="fixed left-0 right-0 z-50 bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg animate-slideDown"
      style={{ top: "env(safe-area-inset-top, 0px)" }}
    >
      <div className="max-w-4xl mx-auto px-4 py-3">
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-start gap-3 flex-1">
            <div className="flex-shrink-0 mt-1">
              <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                <FaLink size={20} />
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-semibold text-sm mb-1 flex items-center gap-2">
                <FaApple size={18} />
                Using Apple's "Hide My Email"?
              </h3>
              <p className="text-xs text-white/90 mb-2">
                You're signed in with a private relay email. Link your Google
                account to access your account from multiple sign-in methods.
              </p>
              <Link
                to="/settings"
                onClick={onDismiss}
                className="inline-flex items-center gap-2 text-xs font-medium bg-white/20 hover:bg-white/30 px-3 py-1.5 rounded-full transition-colors"
              >
                <FaGoogle size={14} />
                Link Google Account
              </Link>
            </div>
          </div>
          <button
            onClick={onDismiss}
            className="flex-shrink-0 w-8 h-8 flex items-center justify-center hover:bg-white/10 rounded-full transition-colors"
            aria-label="Dismiss"
          >
            <FaTimes size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountLinkingBanner;
